import { BarcodeFormat } from "@zxing/library";

export class BarcodeCodeType {
  id: number;
  sigla: string;
  descrizione: string;
  default: boolean;

  constructor(_id: number, _sigla: string, _descrizione: string, _default: boolean = false) {
    this.id = _id;
    this.sigla = _sigla;
    this.descrizione = _descrizione;
    this.default = _default;
  }
}

export class BarcodeType {
  static readonly QR_CODE = new BarcodeCodeType(1, 'QR_CODE', 'QR Code', true);
  static readonly CODABAR = new BarcodeCodeType(2, 'CODABAR', 'Codabar', true);
  static readonly AZTEC = new BarcodeCodeType(3, 'AZTEC', 'Aztec', true);
  static readonly CODE_39 = new BarcodeCodeType(4, 'CODE_39', 'Code 39', true);
  static readonly CODE_93 = new BarcodeCodeType(5, 'CODE_93', 'Code 93', true);
  static readonly CODE_128 = new BarcodeCodeType(6, 'CODE_128', 'Code 128', true);
  static readonly DATA_MATRIX = new BarcodeCodeType(7, 'DATA_MATRIX', 'Data Matrix', true);
  static readonly EAN_8 = new BarcodeCodeType(8, 'EAN_8', 'EAN-8', true);
  static readonly EAN_13 = new BarcodeCodeType(9, 'EAN_13', 'EAN-13', true);
  static readonly ITF = new BarcodeCodeType(10, 'ITF', 'ITF', true);
  static readonly MAXICODE = new BarcodeCodeType(11, 'MAXICODE', 'MaxiCode', true);
  static readonly PDF_417 = new BarcodeCodeType(12, 'PDF_417', 'PDF417', true);
  static readonly RSS_14 = new BarcodeCodeType(13, 'RSS_14', 'RSS 14', true);
  static readonly RSS_EXPANDED = new BarcodeCodeType(6, 'RSS_EXPANDED', 'RSS Expanded', true);
  static readonly UPC_A = new BarcodeCodeType(14, 'UPC_A', 'UPC-A', true);
  static readonly UPC_E = new BarcodeCodeType(15, 'UPC_E', 'UPC-E', true);
  static readonly UPC_EAN_EXTENSION = new BarcodeCodeType(16, 'UPC_EAN-EXTENSION', 'UPC-EAN-EXTENSION', true);

  static get allBarcodeTypes(): BarcodeCodeType[] {
    const myBarcodeTypes: BarcodeCodeType[] = [];
    myBarcodeTypes.push(BarcodeType.QR_CODE, BarcodeType.CODABAR, BarcodeType.AZTEC, BarcodeType.CODE_39, BarcodeType.CODE_93, BarcodeType.CODE_128, BarcodeType.DATA_MATRIX, BarcodeType.EAN_8, BarcodeType.EAN_13, BarcodeType.ITF, BarcodeType.MAXICODE, BarcodeType.PDF_417, BarcodeType.RSS_14, BarcodeType.RSS_EXPANDED, BarcodeType.UPC_A, BarcodeType.UPC_E, BarcodeType.UPC_EAN_EXTENSION);

    return myBarcodeTypes
  }

  static get allBarcodeFormats(): BarcodeFormat[] {
    const myBarcodeTypes: BarcodeFormat[] = [];
    BarcodeType.allBarcodeTypes.forEach((x) => {
      myBarcodeTypes.push(x.sigla as unknown as BarcodeFormat);
    })

    return myBarcodeTypes
  }

  static get defaultBarcodeTypes(): BarcodeCodeType[] {
    return BarcodeType.allBarcodeTypes.filter(x => x.default);
  }

  static get defaultBarcodeFormats(): BarcodeFormat[] {
    const myBarcodeTypes: BarcodeFormat[] = [];
    BarcodeType.defaultBarcodeTypes.forEach((x) => {
      myBarcodeTypes.push(x.sigla as unknown as BarcodeFormat);
    })

    return myBarcodeTypes
  }

  static getBarcodeFormats(barcodeCodeType: BarcodeCodeType[]): BarcodeFormat[] {
    const myBarcodeTypes: BarcodeFormat[] = [];
    barcodeCodeType.forEach((x) => {
      myBarcodeTypes.push(x.sigla as unknown as BarcodeFormat);
    })

    return myBarcodeTypes
  }
}
